import { render, staticRenderFns } from "./FasyankesAdd.vue?vue&type=template&id=2a5b0f21&scoped=true"
import script from "./FasyankesAdd.vue?vue&type=script&lang=js"
export * from "./FasyankesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5b0f21",
  null
  
)

export default component.exports